import { gql } from '@apollo/client';

export const getActivePersonsQuery = gql`
  query {
    salesforce {
      getActivePersons {
        id
        fullName
      }
    }
  }
`;
export const getActivePersonsWithoutBusinessPartnersQery = gql`
  query {
    salesforce {
      getActivePersonsWithoutBusinessPartners {
        id
        fullName
        status
      }
    }
  }
`;

export const getPersonDetailsQuery = gql`
  query getPersonDetails($id: String!) {
    salesforce {
      getPersonDetails(id: $id) {
        email
        phoneDetails {
          phoneNumber
          phoneType
        }
      }
    }
  }
`;

export const getRelatedCompaniesQuery = gql`
  query {
    salesforce {
      getRelatedCompanies {
        id
        title
        code
      }
    }
  }
`;

export const getCountriesQuery = gql`
  query {
    core {
      getCountries {
        id
        title
        code
      }
    }
  }
`;

export const getZonesQuery = gql`
  query {
    core {
      getZones {
        id
        title
        code
      }
    }
  }
`;

export const getCurrenciesQuery = gql`
  query {
    core {
      getCurrencies {
        id
        title
        code
        symbol
      }
    }
  }
`;

export const getTitlesQuery = gql`
  query {
    core {
      getTitles {
        id
        title
        code
      }
    }
  }
`;

export const createBusinessPartnerMutation = gql`
  mutation createBusinessPartner(
    $createBusinessPartnerInput: CreateBusinessPartnerInput!
  ) {
    salesforce {
      createBusinessPartner(
        createBusinessPartnerInput: $createBusinessPartnerInput
      )
    }
  }
`;

export const getBusinessPartnerTypeEnumQuery = gql`
  query {
    BusinessPartnerType: __type(name: "BusinessPartnerType") {
      name
      enumValues {
        name
      }
    }
  }
`;

export const getActiveBusinessPartnersQuery = gql`
  query {
    salesforce {
      searchBusinessPartners(
        statuses: ["Active"]
        pagination: { pageNumber: 1, pageSize: 100000000 }
      ) {
        items {
          id
          code
          fullName
        }
      }
    }
  }
`;

export const searchActiveBusinessPartnersQuery = gql`
  query SearchActiveBusinessPartners(
    $keyword: String
    $pagination: PaginationInput
  ) {
    salesforce {
      searchBusinessPartners(
        keyword: $keyword
        statuses: ["Active"]
        pagination: $pagination
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          id
          code
          fullName
        }
      }
    }
  }
`;

export const getBPAgencyListQuery = gql`
  query getBPAgencyList {
    salesforce {
      getBPAgencyList {
        id
        code
        title
      }
    }
  }
`;
